import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Checklist/MinhasMetas/Content";

const ChecklistMyMetas = () => {
    return(
        <>
            <NavBar title="MINHAS METAS CHECKLIST" prevDest="./../../modulo/ssma/check-list/" />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    )
}

export default ChecklistMyMetas;